<template>
  <b-row>
    <b-col md="6">
      <b-form-group
        label-class="font-weight-bold my-0 py-0"
        label-for="order"
        class="mb-0"
      >
        <b-form-select
          id="order"
          :class="sortDropdownClass"
          size="sm"
          v-model="selectedSortMethod"
          :options="sortMethods"
          @change="$emit('sort', selectedSortMethod)"
          ></b-form-select>
      </b-form-group>
    </b-col>
    <b-col md="6">
      <b-form-group
        label-class="font-weight-bold my-0 py-0"
        label-for="itemsPerPage"
        class="mb-0"
      >
        <b-form-select
          id="itemsPerPage"
          size="sm"
          v-model="selectedResultsPerPage"
          :options="resultsPerPage"
          @change="$emit('pagination', selectedResultsPerPage)"
          >
          </b-form-select>
      </b-form-group>
    </b-col>
  </b-row>
</template>

<script>
import formMixin from '@/app/private/shared/mixins/search_forms'

export default {
  name: 'SortFields',
  mixins: [formMixin]
}

</script>
